import React from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Space, Typography } from 'antd';

import { AtomRow } from './AtomRow';
import { ConditionGroup } from '../../types';
import { uid } from '../../utils/helpers';

interface GroupBoxProps {
  group: ConditionGroup;
  onChange: (g: ConditionGroup) => void;
  onRemove: () => void;
  onAddGroup?: () => void;
  canRemove?: boolean;
}

export function GroupBox({ group, onChange, onRemove, onAddGroup, canRemove = true }: GroupBoxProps) {
  const canRemoveAtoms = group.atoms.length > 1;

  return (
    <Card
      size="small"
      bodyStyle={{ paddingTop: 12 }}
      style={{ borderColor: '#8c8c8c' }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        marginBottom: 12
      }}>
        {onAddGroup && (
          <Button type="default" size="small" onClick={onAddGroup}>
            И
          </Button>
        )}
        <Button
          type="default"
          size="small"
          onClick={() =>
            onChange({
              ...group,
              logic: 'OR',
              atoms: [
                ...group.atoms,
                { id: uid(), metric: 'users_count', comparator: '>', value: '', periodDays: group.atoms[0]?.periodDays ?? 0, periodDaysUntil: group.atoms[0]?.periodDaysUntil ?? 0, unit: 'rub' },
              ],
            })
          }
        >
          ИЛИ
        </Button>
        {canRemove && (
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={onRemove}
            size="small"
            style={{ color: 'rgba(0, 0, 0, 0.88)' }}
          />
        )}
      </div>
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        {group.atoms.map((a, idx) => (
          <Space key={a.id} direction="vertical" style={{ width: '100%' }}>
            <AtomRow
              atom={a}
              onChange={(next) => onChange({ ...group, atoms: group.atoms.map((x) => (x.id === a.id ? next : x)) })}
              onRemove={canRemoveAtoms ? () => onChange({ ...group, atoms: group.atoms.filter((x) => x.id !== a.id) }) : undefined}
            />
            {idx < group.atoms.length - 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>ИЛИ</Typography.Text>
              </div>
            )}
          </Space>
        ))}
      </Space>
    </Card>
  );
}
